<template>
  <div>
    <b-card no-header>
      <b-form>
        <app-briefs
          label="Brief"
          :nombre="briefNombre"
          :lista="list"
          :labelCols="labelCols"
          labelOption="Seleccione un brief"
          @updated="briefActualizado">
        </app-briefs>  
      </b-form>

      <b-alert
        class="alert"
        :show="dismissCountDown"
        dismissible
        fade
        :variant="alertVariant"
        @dismissed="dismissCountDown = 0"
        @dismiss-count-down="countDownChanged">
        <p>{{ alertMsj }}</p>
      </b-alert>             

      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          ref="seleccionarButton"
          @click.prevent="seleccionar">Seleccionar</b-button>
        <b-button size="sm" variant="danger" class="footer-button"
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import Briefs from '../shared/abmSelect.vue';
import moment from 'moment';

export default {
  name: 'PresupuestosInternosBriefs',
  components: {
    appBriefs: Briefs,
  },
  props: {
    presupuestoInternoId: {
      type: Number,
      default: 0
    },
  },
  data: () => {
    return {
      brief: null,
      briefs: [],
      list: [],

      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: '',
      
      labelCols: 2
    }
  },
  computed: {
    'briefNombre': function() {
      if (this.brief) {
        return `${this.brief.cliente? this.brief.cliente.trim() : ''} - ${this.brief.accion}`;
      }
      return null;
    },
  },
  created() {
    this.getBriefs();
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert(alertMsj, alertVariant) {
      this.alertMsj = alertMsj;
      this.alertVariant = alertVariant;
      this.dismissCountDown = this.alertCountDown;
    },
    getBriefs() {
      this.showSpinner();
      this.$store.dispatch('briefs/getBriefsByPresupuesto', this.presupuestoInternoId)
        .then(() => {
          this.briefs = this.$store.getters['briefs/searchList'];
          this.list = this.briefs.map(brief => `${brief.cliente? brief.cliente.trim() : ''} - ${brief.accion}`);
        })
        .catch(error => this.showAlert(error, 'danger'))
        .finally(() => this.hideSpinner())
    },
    briefActualizado(briefNombre) {
      this.brief = null;
      if (briefNombre) {
        this.briefs.forEach(brief => {
          if (`${brief.cliente? brief.cliente.trim() : ''} - ${brief.accion}` == briefNombre.trim()) {
            this.brief = brief;
            return;
          }
        });
      }
    },
    seleccionar() {
      if (this.brief) {
        this.$emit('briefSeleccionado', this.brief.id);
      } else {
        this.showAlert('Debe seleccionar un subtrabajo.', 'danger');
      }
    },
    cancelar () {
      this.$emit('closeSeleccionBrief');
    },
  },
}
</script>

<style>
</style>
